// Digest: 4b3af7e6612b53362c439c9d0300d469f0720595
/* eslint-disable */
/// <reference types="vite/client.d.ts" />/* eslint-disable */
/**
 * This file was automatically generated by json-schema-to-typescript.
 * DO NOT MODIFY IT BY HAND. Instead, modify the source JSONSchema file,
 * and run json-schema-to-typescript to regenerate this file.
 */

export type ContainerSizeSubBlockOrNull = null | ContainerSizeSubBlock;
export type AlignedRichTextSubBlockOrNull = null | AlignedRichTextSubBlock;
export type RichTextBlockOrNull = null | RichTextBlock;
export type RichTextBlock = string;
export type _SlideListOrNull = null | _SlideList;
export type ImageChooserBlockOrNull = null | ImageChooserBlock;
export type _SlideList = _Slide[];
export type CharBlockOrNull = null | CharBlock;
export type CharBlock = string;
export type EmbedBlockOrNull = null | EmbedBlock;
export type EmbedBlock = string;
export type MediaChooserBlock = (
  | {
      type: "image";
      value: ImageChooserBlock;
      id: string;
    }
  | {
      type: "video";
      value: VideoChooserBlock;
      id: string;
    }
  | {
      type: "embed";
      value: MediaEmbedBlock;
      id: string;
    }
)[];
export type URLBlockOrNull = null | URLBlock;
export type URLBlock = string;
export type TableBlockOrNull = null | TableBlock;
export type TableBlock = string;
export type LabUIToolbox = (
  | {
      type: "alignedrichtextblock";
      value: AlignedRichTextBlock;
      id: string;
    }
  | {
      type: "gallerysubblock";
      value: GallerySubBlock;
      id: string;
    }
  | {
      type: "linksubblock";
      value: LinkSubBlock;
      id: string;
    }
  | {
      type: "mediachooserblock";
      value: MediaChooserBlock;
      id: string;
    }
  | {
      type: "scrollnavmenublock";
      value: ScrollNavMenuBlock;
      id: string;
    }
  | {
      type: "scrollnavmenuitemblock";
      value: ScrollNavMenuItemBlock;
      id: string;
    }
  | {
      type: "socialmediaicon";
      value: SocialMediaIcon;
      id: string;
    }
  | {
      type: "spacerblock";
      value: SpacerBlock;
      id: string;
    }
  | {
      type: "tableincontainerblock";
      value: TableInContainerBlock;
      id: string;
    }
  | {
      type: "onetrustprivacynoticeblock";
      value: OneTrustPrivacyNoticeBlock;
      id: string;
    }
  | {
      type: "videochooserblock";
      value: VideoChooserBlock;
      id: string;
    }
)[];
export type CollectionNameStylesSubBlockOrNull = null | CollectionNameStylesSubBlock;
export type TsicommonCmsRichNavigationLinkListOrNull = null | TsicommonCms;
export type TsicommonCmsPromoPeriodOrNull = null | TsicommonCms2;
export type TsicommonCmsLinkOrNull = null | TsicommonCms3;
export type FlairSubBlockOrNull = null | FlairSubBlock;
export type _PromoBubbleOrNull = null | _PromoBubble;
export type ProductChooserSubBlockOrNull = null | ProductChooserSubBlock;
export type ProductChooserSubBlock = number;
export type RichNavigationLinkTypes = (
  | {
      type: "rich_nav_general_link";
      value: _RichNavigation__GeneralLink;
      id: string;
    }
  | {
      type: "rich_nav_offer_link";
      value: _RichNavigation__OfferLink;
      id: string;
    }
  | {
      type: "rich_nav_product_link";
      value: _RichNavigation__ProductLink;
      id: string;
    }
  | {
      type: "rich_nav_dynamic_product_link";
      value: _RichNavigation__DynamicProductLink;
      id: string;
    }
  | {
      type: "rich_nav_image_link";
      value: _RichNavigation__ImageLink;
      id: string;
    }
  | {
      type: "rich_nav_button_link";
      value: _RichNavigation__ButtonLink;
      id: string;
    }
  | {
      type: "rich_nav_banner_link";
      value: _RichNavigation__BannerLink;
      id: string;
    }
)[];
export type TsicommonCms = TsicommonCms1[];
export type RichNavigationPromoFeaturesAssemblyOrNull = null | RichNavigationPromoFeaturesAssembly;
export type RichNavigationPromoFeaturesAssembly = {
  type: "image_promo";
  value: RichNavigationImagePromo;
  id: string;
}[];
export type RichNavigationContentAssembly = (
  | {
      type: "rich_nav_link_collection";
      value: RichNavigationLinkCollection;
      id: string;
    }
  | {
      type: "link";
      value: TsicommonCms3;
      id: string;
    }
  | {
      type: "closest_store_selection";
      value: CurrentStoreSection;
      id: string;
    }
)[];
export type ResponsiveVisibilitySubBlockOrNull = null | ResponsiveVisibilitySubBlock;
export type SpacingSubBlockOrNull = null | SpacingSubBlock;
export type BackgroundStylesSubBlockOrNull = null | BackgroundStylesSubBlock;
export type BackgroundImageShiftSubBlockOrNull = null | BackgroundImageShiftSubBlock;
export type IntegerBlockOrNull = null | IntegerBlock;
export type IntegerBlock = number;
export type RichNavigationBannerContentAssembly = {
  type: "banner";
  value: BannerBlock;
  id: string;
}[];
export type TextBlock = string;
export type PromoHeaderBlock = {
  type: "promo";
  value: Cms;
  id: string;
}[];
export type FreightDeliverySteps = (
  | {
      type: "order_confirmed";
      value: OrderConfirmed;
      id: string;
    }
  | {
      type: "order_processing";
      value: OrderProcessing;
      id: string;
    }
  | {
      type: "order_prepared_for_shipment";
      value: OrderPreparedForShipment;
      id: string;
    }
  | {
      type: "order_shipped";
      value: OrderShipped;
      id: string;
    }
  | {
      type: "ready_for_delivery";
      value: ReadyForDelivery;
      id: string;
    }
  | {
      type: "delivery_scheduled";
      value: DeliveryScheduled;
      id: string;
    }
  | {
      type: "out_for_delivery";
      value: OutForDelivery;
      id: string;
    }
  | {
      type: "Delivered";
      value: Delivered;
      id: string;
    }
)[];
export type TRSDeliverySteps = (
  | {
      type: "order_confirmed";
      value: OrderConfirmed;
      id: string;
    }
  | {
      type: "order_shipped";
      value: OrderShipped;
      id: string;
    }
  | {
      type: "ready_for_delivery";
      value: ReadyForDelivery;
      id: string;
    }
  | {
      type: "delivery_scheduled";
      value: DeliveryScheduled;
      id: string;
    }
  | {
      type: "out_for_delivery";
      value: OutForDelivery;
      id: string;
    }
  | {
      type: "Delivered";
      value: Delivered;
      id: string;
    }
)[];
export type SmallPackageDeliverySteps = (
  | {
      type: "order_confirmed";
      value: OrderConfirmed;
      id: string;
    }
  | {
      type: "order_processing";
      value: OrderProcessing;
      id: string;
    }
  | {
      type: "order_prepared_for_shipment";
      value: OrderPreparedForShipment;
      id: string;
    }
  | {
      type: "order_shipped";
      value: OrderShipped;
      id: string;
    }
  | {
      type: "Delivered";
      value: Delivered;
      id: string;
    }
)[];
export type PageChooserBlockOrNull = null | PageChooserBlock;
export type BooleanBlockOrNull = null | BooleanBlock;
export type BooleanBlock = boolean;
export type TrackingPageCategory = (
  | {
      type: "link";
      value: LinkBlock;
      id: string;
    }
  | {
      type: "children";
      value: {
        type: "link";
        value: LinkBlock;
        id: string;
      }[];
      id: string;
    }
)[];
export type TrackingPageSidebar = {
  type: "category";
  value: TrackingPageCategory;
  id: string;
}[];
export type TsicommonCmsShopTileOrNull = null | TsicommonCms4;
export type TsicommonCmsCompareFeatureOrNull = null | TsicommonCms6;
export type CompareFeatureBody = {
  type: "feature";
  value: CompareFeatureBlock;
  id: string;
}[];
export type CompareTileSnippetBody = {
  type: "compare_tile";
  value: TsicommonCms5;
  id: string;
}[];
export type ConditionalShopTileBody = {
  type: "conditional_shop_tile";
  value: ConditionalShopTileBlock;
  id: string;
}[];
export type CompareFeatureSnippetBody = {
  type: "compare_feature";
  value: TsicommonCms6;
  id: string;
}[];

export interface _Types {
  BasePageTemplateProps: ThelabuiModelsPagesBasePageBasePageTemplate;
  BaseFormPageTemplateProps: ThelabuiModelsPagesBaseFormPageBaseFormPageTemplate;
  BaseFormPageLandingPageTemplateProps: ThelabuiModelsPagesBaseFormPageBaseFormPageLandingPageTemplate;
  ExamplePageTemplateProps: ThelabuiModelsPagesExamplePageExamplePageTemplate;
  LabUIToolboxSnippetPreviewProps: ThelabuiModelsSnippetsToolboxSnippetLabUIToolboxSnippetPreview;
  CheckoutHeaderTemplateProps: ServerCmsTemplatesCheckoutHeaderTemplate;
  SiteHeaderTemplateProps: ServerCmsTemplatesSiteHeaderTemplate;
  RichNavigationTemplateProps: TsicommonCmsTemplatesRichNavigationTemplate;
  FlairSubBlockTemplateProps: TsicommonCmsTemplatesFlairSubBlockTemplate;
  DynamicPriceTemplateProps: TsicommonCmsTemplatesDynamicPriceTemplate;
  TrackOrderDetailsTemplateProps: TsicommonCmsTemplatesTrackOrderDetailsTemplate;
  ValuePropBarBlockTemplateProps: TsicommonCmsTemplatesValuePropBarBlockTemplate;
  ShopCompareGridTemplateProps: TsicommonCmsTemplatesShopCompareGridTemplate;
  ShopTileTemplateProps: TsicommonCmsTemplatesShopTileTemplate;
  TabFeatureAttributeBlockTemplateProps: TsicommonCmsTemplatesTabFeatureAttributeBlockTemplate;
  OrderNumberPopupTemplateProps: TsicommonCmsTemplatesOrderNumberPopupTemplate;
  TrackOrderSummaryTemplateProps: TsicommonCmsTemplatesTrackOrderSummaryTemplate;
  globals: {
    Widget: generated.Types["Widget"];
    models: {};
  };
  Context: ReactivatedSerializationContextProcessorsBaseContext &
    ReactivatedSerializationContextProcessorsCSRFProcessor &
    ReactivatedSerializationContextProcessorsRequestProcessor &
    ReactivatedSerializationContextProcessorsStaticProcessor &
    ThelabuiContextProcessorsTranslationProcessor &
    ServerContextProcessorsSiteURLContext &
    ServerContextProcessorsSiteSettingsContext;
  RPCPermission: null;
}
export interface ThelabuiModelsPagesBasePageBasePageTemplate {
  is_preview: boolean;
  page: BasePageEb66F00405;
}
export interface BasePageEb66F00405 {
  id: number;
  title: string;
  seo_title: string;
  search_description: string;
  first_published_at: string | null;
  language: ThelabuiTypesLanguage | null;
  alternate_pages: ThelabuiTypesAlternatePage[];
}
export interface ThelabuiTypesLanguage {
  code: string;
  vernacular_name: string;
  translated_name: string;
  dir: "ltr" | "rtl" | "auto";
}
export interface ThelabuiTypesAlternatePage {
  title: string;
  url: string;
  language: ThelabuiTypesLanguage;
}
export interface ThelabuiModelsPagesBaseFormPageBaseFormPageTemplate {
  is_preview: boolean;
  page: BaseFormPageFe4F84D43A;
  form: DjangoFormsForms;
}
export interface BaseFormPageFe4F84D43A {
  id: number;
  title: string;
  seo_title: string;
  search_description: string;
  first_published_at: string | null;
  language: ThelabuiTypesLanguage | null;
  alternate_pages: ThelabuiTypesAlternatePage[];
}
export interface DjangoFormsForms {
  name: "django.forms.forms.Form";
  errors: {} | null;
  fields: {};
  prefix: string;
  iterator: [];
  hidden_fields?: [];
}
export interface ThelabuiModelsPagesBaseFormPageBaseFormPageLandingPageTemplate {
  is_preview: boolean;
  page: BaseFormPageFe4F84D43A;
}
export interface ThelabuiModelsPagesExamplePageExamplePageTemplate {
  is_preview: boolean;
  page: ExamplePage_8C9639Cb8F;
}
export interface ExamplePage_8C9639Cb8F {
  id: number;
  title: string;
  seo_title: string;
  search_description: string;
  first_published_at: string | null;
  language: ThelabuiTypesLanguage | null;
  alternate_pages: ThelabuiTypesAlternatePage[];
  image: {
    block: ThelabuiSerializationImagesImageBlockValue;
  } | null;
  image_tile: {
    renditions_webp: WagtailImageRendition[];
  } | null;
  richtext: RichTextField;
  body: ThelabuiExamplePage;
  snippets: {
    body: ThelabuiLabUIToolboxSnippet;
  }[];
  attachment: {
    title: string;
    created_at: string;
    file_size: number | null;
    file_hash: string;
    filename: string;
    file_extension: string;
    url: string;
    content_type: string;
    content_disposition: string;
    file: FileField;
    tags: {
      name: string;
    }[];
  } | null;
}
export interface ThelabuiSerializationImagesImageBlockValue {
  title: string;
  description: string;
  default_alt_text: string;
  width: number;
  height: number;
  brightness: number | null;
  url: string;
  renditions: {
    [k: string]: ThelabuiSerializationImagesImageRenditionBlockValue;
  };
  imageData: string | null;
}
export interface ThelabuiSerializationImagesImageRenditionBlockValue {
  spec: string;
  width: number;
  height: number;
  url: string;
  size: number;
  mimetype: string;
}
export interface WagtailImageRendition {
  spec: string;
  width: number;
  height: number;
  url: string;
  size: number;
  mimetype: string;
}
export interface RichTextField {
  _type: "RichTextField";
  html: string;
}
export interface ThelabuiExamplePage {
  _type: "StreamField";
  _variant: "thelabui.ExamplePage.body";
  value: LabUIToolbox;
  [k: string]: unknown;
}
export interface AlignedRichTextBlock {
  container?: ContainerSizeSubBlockOrNull;
  content?: AlignedRichTextSubBlockOrNull;
}
export interface ContainerSizeSubBlock {
  width?: null | ("" | "full" | "twoThirds" | "half");
}
export interface AlignedRichTextSubBlock {
  content?: RichTextBlockOrNull;
  alignment?: null | ("" | "textAlignCenter" | "textAlignRight");
}
export interface GallerySubBlock {
  slides?: _SlideListOrNull;
}
export interface _Slide {
  image: ImageChooserBlockOrNull;
  caption?: AlignedRichTextSubBlockOrNull;
}
export interface ImageChooserBlock {
  title: string;
  description: string;
  default_alt_text: string;
  width: number;
  height: number;
  brightness: null | number;
  url: string;
  renditions: {
    /**
     * This interface was referenced by `undefined`'s JSON-Schema definition
     * via the `patternProperty` "^.*$".
     */
    [k: string]: {
      spec: string;
      width: number;
      height: number;
      url: string;
      size: number;
      mimetype: string;
    };
  };
  imageData: null | string;
}
export interface LinkSubBlock {
  display_name?: CharBlockOrNull;
  link_type?: null | ("page" | "external" | "email" | "document");
  anchor?: CharBlockOrNull;
  link_style?: null | ("" | "secondary" | "text-link");
  url: null | string;
}
export interface VideoChooserBlock {
  poster: null | string;
  sources: {
    url: string;
    mimetype: string;
  }[];
  title: string;
  tracks: {
    kind: string;
    kind_name: string;
    src: string;
    label: string;
    srclang: string;
    srclang_name: null | string;
    sort_order: number;
  }[];
  width: null | number;
  height: null | number;
  aspectRatio: null | number;
}
export interface MediaEmbedBlock {
  title: CharBlockOrNull;
  thumbnail: ImageChooserBlockOrNull;
  embed: EmbedBlockOrNull;
}
export interface ScrollNavMenuBlock {}
export interface ScrollNavMenuItemBlock {
  name: CharBlockOrNull;
}
export interface SocialMediaIcon {
  icon: null | ("facebook" | "instagram" | "linkedin" | "pinterest" | "tiktok" | "twitter" | "youtube");
  link: URLBlockOrNull;
}
export interface SpacerBlock {
  anchor?: CharBlockOrNull;
  height: null | ("no-height" | "small" | "medium" | "large" | "xlarge" | "xxlarge");
}
export interface TableInContainerBlock {
  container?: ContainerSizeSubBlockOrNull;
  table: TableBlockOrNull;
}
export interface OneTrustPrivacyNoticeBlock {
  script_url: URLBlockOrNull;
  callback_url: URLBlockOrNull;
  notice_url: URLBlockOrNull;
}
export interface ThelabuiLabUIToolboxSnippet {
  _type: "StreamField";
  _variant: "thelabui.LabUIToolboxSnippet.body";
  value: LabUIToolbox;
  [k: string]: unknown;
}
export interface FileField {
  url: string;
}
export interface ThelabuiModelsSnippetsToolboxSnippetLabUIToolboxSnippetPreview {
  object: LabUIToolboxSnippetFdc2906E1B;
}
export interface LabUIToolboxSnippetFdc2906E1B {
  id: number;
  name: string;
  body: ThelabuiLabUIToolboxSnippet;
}
export interface ServerCmsTemplatesCheckoutHeaderTemplate {
  app_slug: string;
  root_page_url: string;
  encoded_basket_id: string;
  support_website_phone_number: string;
}
export interface ServerCmsTemplatesSiteHeaderTemplate {
  rich_navigation: RichNavigationC5Fd9Ac9C3 | null;
  promo_settings: PromoSettings_7E01A84Bf5;
  messages: ServerCmsTemplatesMessage[];
  user: ServerCmsTemplatesUser | null;
  show_admin_tools: boolean;
  access_admin: boolean;
  top_nav_menu: NavMenu_16B601C491;
}
export interface RichNavigationC5Fd9Ac9C3 {
  name: string;
  content: TsicommonCmsRichNavigation | null;
  banner_content: TsicommonCmsRichNavigation1 | null;
  value_props: {
    value_prop: {
      title: RichTextField;
      icon: {
        block: ThelabuiSerializationImagesImageBlockValue1;
      } | null;
    };
    link: {
      url: string;
    } | null;
  }[];
}
export interface TsicommonCmsRichNavigation {
  _type: "StreamField";
  _variant: "tsicommon_cms.RichNavigation.content";
  value: RichNavigationContentAssembly;
  [k: string]: unknown;
}
export interface RichNavigationLinkCollection {
  name: CharBlockOrNull;
  collection_name_style?: CollectionNameStylesSubBlockOrNull;
  variant?:
    | null
    | (
        | ""
        | "rich-navigation--link-collection--two-thirds-link"
        | "rich-navigation--link-collection--single-column"
        | "rich-navigation--link-collection--heart"
        | "rich-navigation--link-collection--no-title"
        | "rich-navigation--link-collection--inspiration"
      );
  links?: TsicommonCmsRichNavigationLinkListOrNull;
  cta_link?: TsicommonCmsLinkOrNull;
  cta_text?: CharBlockOrNull;
  promo_features?: RichNavigationPromoFeaturesAssemblyOrNull;
}
export interface CollectionNameStylesSubBlock {
  style?: null | "";
}
export interface TsicommonCms1 {
  value: RichNavigationLinkTypes;
}
export interface _RichNavigation__GeneralLink {
  promo_period?: TsicommonCmsPromoPeriodOrNull;
  destination: TsicommonCmsLinkOrNull;
  text: RichTextBlockOrNull;
  flair?: FlairSubBlockOrNull;
  image: ImageChooserBlockOrNull;
}
export interface TsicommonCms2 {
  is_promo_active?: boolean;
}
export interface TsicommonCms3 {
  id: number;
  title: string;
  url: string;
}
export interface FlairSubBlock {
  style?:
    | null
    | (
        | ""
        | "flair--breeze"
        | "flair--lightning-bolt"
        | "flair--razzmatazz-angle"
        | "flair--razzmatazz"
        | "flair--razzmatazz-pill"
        | "flair--razzmatazz-pill-small-txt"
        | "flair--light-pink-pill-small-txt"
        | "flair--pink-rect"
        | "flair--underline"
        | "flair--wifi"
        | "flair--adapt"
        | "flair--black-pill"
        | "flair--black-rect"
        | "flair--downriver-rectangle"
        | "flair--white-with-shadow"
      );
  content?: RichTextBlockOrNull;
}
export interface _RichNavigation__OfferLink {
  promo_period?: TsicommonCmsPromoPeriodOrNull;
  offer: TsicommonCmsLinkOrNull;
  image: ImageChooserBlockOrNull;
  text: RichTextBlockOrNull;
  flair?: FlairSubBlockOrNull;
}
export interface _RichNavigation__ProductLink {
  promo_period?: TsicommonCmsPromoPeriodOrNull;
  destination: TsicommonCmsLinkOrNull;
  text: RichTextBlockOrNull;
  flair?: FlairSubBlockOrNull;
  image: ImageChooserBlockOrNull;
  subtitle?: RichTextBlockOrNull;
  callout?: RichTextBlockOrNull;
  promo_bubble?: _PromoBubbleOrNull;
}
export interface _PromoBubble {
  text?: CharBlockOrNull;
  image?: ImageChooserBlockOrNull;
}
export interface _RichNavigation__DynamicProductLink {
  promo_period?: TsicommonCmsPromoPeriodOrNull;
  destination: TsicommonCmsLinkOrNull;
  text: RichTextBlockOrNull;
  flair?: FlairSubBlockOrNull;
  image: ImageChooserBlockOrNull;
  title?: RichTextBlockOrNull;
  secondary_flair?: FlairSubBlockOrNull;
  product: ProductChooserSubBlockOrNull;
  price?: {
    currency: string | null;
    excl_tax: string | null;
    incl_tax: string | null;
    tax: string | null;
    retail?: string | null;
    cosmetic_excl_tax?: string | null;
    cosmetic_incl_tax?: string | null;
    enable_per_month_pricing?: boolean;
    per_month?: string | null;
    per_month_term_length?: number | null;
    post_discount_addons?: {
      name: string;
      price_excl_tax: string;
    }[];
  };
}
export interface _RichNavigation__ImageLink {
  promo_period?: TsicommonCmsPromoPeriodOrNull;
  destination: TsicommonCmsLinkOrNull;
  text: RichTextBlockOrNull;
  image: ImageChooserBlockOrNull;
}
export interface _RichNavigation__ButtonLink {
  promo_period?: TsicommonCmsPromoPeriodOrNull;
  destination: TsicommonCmsLinkOrNull;
  text: RichTextBlockOrNull;
}
export interface _RichNavigation__BannerLink {
  promo_period?: TsicommonCmsPromoPeriodOrNull;
  destination: TsicommonCmsLinkOrNull;
  text: RichTextBlockOrNull;
  flair?: FlairSubBlockOrNull;
}
export interface RichNavigationImagePromo {
  promo_period?: TsicommonCmsPromoPeriodOrNull;
  link?: TsicommonCmsLinkOrNull;
  image: ImageChooserBlockOrNull;
}
export interface CurrentStoreSection {}
export interface TsicommonCmsRichNavigation1 {
  _type: "StreamField";
  _variant: "tsicommon_cms.RichNavigation.banner_content";
  value: RichNavigationBannerContentAssembly;
  [k: string]: unknown;
}
export interface BannerBlock {
  responsive_visibility?: ResponsiveVisibilitySubBlockOrNull;
  spacing?: SpacingSubBlockOrNull;
  background_style?: BackgroundStylesSubBlockOrNull;
  content: RichTextBlockOrNull;
}
export interface ResponsiveVisibilitySubBlock {
  visibility?:
    | null
    | (
        | ""
        | "responsive-visibility--small-only"
        | "responsive-visibility--medium-only"
        | "responsive-visibility--medium-and-smaller"
        | "responsive-visibility--medium-and-larger"
        | "responsive-visibility--large-only"
      );
}
export interface SpacingSubBlock {
  top_spacing?:
    | null
    | ("" | "spacing--xtra-small" | "spacing--small" | "spacing--medium" | "spacing--large" | "spacing--xtra-large");
  top_inner_spacing?:
    | null
    | ("" | "spacing--xtra-small" | "spacing--small" | "spacing--medium" | "spacing--large" | "spacing--xtra-large");
  bottom_spacing?:
    | null
    | ("" | "spacing--xtra-small" | "spacing--small" | "spacing--medium" | "spacing--large" | "spacing--xtra-large");
  bottom_inner_spacing?:
    | null
    | ("" | "spacing--xtra-small" | "spacing--small" | "spacing--medium" | "spacing--large" | "spacing--xtra-large");
}
export interface BackgroundStylesSubBlock {
  style?:
    | null
    | (
        | ""
        | "background--image-full"
        | "background--image-full-height"
        | "background--image-pattern"
        | "background--alabaster"
        | "background--alabaster2"
        | "background--black"
        | "background--breeze-blue"
        | "background--blue-lp-gradient"
        | "background--limed-spruce"
        | "background--dark-grey"
        | "background--blue"
        | "background--navy"
        | "background--razzmatazz"
        | "background--red"
        | "background--white-to-black-radial"
        | "background--white-to-breeze-blue-radial"
        | "background--orient"
        | "background--st-tropaz"
        | "background--st-tropaz-pixel"
        | "background--st-tropaz-gradient"
        | "background--adapt-aqua"
        | "background--adapt-emerald"
        | "background--black-to-adapt-emerald-radial"
      );
  background_image?: ImageChooserBlockOrNull;
  background_image_shift?: BackgroundImageShiftSubBlockOrNull;
}
export interface BackgroundImageShiftSubBlock {
  shift_amount_x?: IntegerBlockOrNull;
}
export interface ThelabuiSerializationImagesImageBlockValue1 {
  title: string;
  description: string;
  default_alt_text: string;
  width: number;
  height: number;
  brightness: number | null;
  url: string;
  renditions: {
    [k: string]: ThelabuiSerializationImagesImageRenditionBlockValue;
  };
  imageData: string | null;
}
export interface PromoSettings_7E01A84Bf5 {
  promo_header: CmsPromoSettings | null;
  show_promo_header: boolean;
}
export interface CmsPromoSettings {
  _type: "StreamField";
  _variant: "cms.PromoSettings.promo_header";
  value: PromoHeaderBlock;
  [k: string]: unknown;
}
export interface Cms {
  title?: TextBlock;
  copy?: RichTextBlock;
  mobile_copy?: RichTextBlock;
}
export interface ServerCmsTemplatesMessage {
  level: number;
  message: string;
  tags: string;
  level_tag: string;
  extra_tags: string;
}
export interface ServerCmsTemplatesUser {
  is_staff: boolean;
}
export interface NavMenu_16B601C491 {
  name: string;
  menu: WagtailNavMenusNavMenu;
}
export interface WagtailNavMenusNavMenu {
  _type: "StreamField";
  _variant: "wagtail_nav_menus.NavMenu.menu";
  value: {
    nav_category?: {
      title: string;
      sub_nav?: unknown[];
    };
    page_link?: {};
    external_link?: {};
    django_url?: {};
    relative_url?: {};
    image?: {};
    html?: {};
    page_link_with_image?: {};
    nav_advert?: {};
    nav_footer?: {};
    snippet_link?: {};
    footer_column?: {};
  };
  [k: string]: unknown;
}
export interface TsicommonCmsTemplatesRichNavigationTemplate {
  rich_navigation: RichNavigationC5Fd9Ac9C3 | null;
}
export interface TsicommonCmsTemplatesFlairSubBlockTemplate {
  style: string;
  content: string;
}
export interface TsicommonCmsTemplatesDynamicPriceTemplate {
  product: string;
}
export interface TsicommonCmsTemplatesTrackOrderDetailsTemplate {
  unified_order: TsicommonOscarappsCustomerServicesUnifiedOrderLookupOrder | null;
  config: OrderPipelineConfig_1E9Aa3253E | null;
  war_link: string;
}
export interface TsicommonOscarappsCustomerServicesUnifiedOrderLookupOrder {
  source: "DTC" | "TRS";
  order_number: string;
  searched_order_number: string;
  created_dt: string;
  customer_email: string | null;
  is_tax_known: boolean | null;
  itemized_tax_groups: TsicommonOscarappsCustomerServicesItemizedTaxGroup[];
  total_discount_excl_tax: string | null;
  total_incl_tax: string;
  basket_total_before_discounts_excl_tax: string;
  shipping_excl_tax: string;
  currency: string;
  shipping_address: TsicommonOscarappsCustomerServicesUnifiedOrderLookupShippingAddress;
  shipments: TsicommonOscarappsCustomerServicesUnifiedOrderLookupOrderShipment[];
}
export interface TsicommonOscarappsCustomerServicesItemizedTaxGroup {
  name: string;
  amount: string;
}
export interface TsicommonOscarappsCustomerServicesUnifiedOrderLookupShippingAddress {
  line1: string;
  line2: string;
  line3: string;
  line4: string;
  state: string;
  postcode: string;
  country: string;
  phone_number: string;
}
export interface TsicommonOscarappsCustomerServicesUnifiedOrderLookupOrderShipment {
  last_mile_carrier_code: string | null;
  last_mile_tracking_number: string | null;
  tracking_url: string | null;
  status_name: string | null;
  status_remark: string | null;
  scheduled_date: string | null;
  lines: TsicommonOscarappsCustomerServicesUnifiedOrderLookupLine[];
  events: TsicommonOscarappsCustomerServicesUnifiedOrderShipmentEvent[];
  has_freight: boolean;
  has_small_package: boolean;
}
export interface TsicommonOscarappsCustomerServicesUnifiedOrderLookupLine {
  product_sku: string;
  product_image: string | null;
  product_title: string;
  product_link: string | null;
  product_attribute_summary: string | null;
  line_price_excl_tax: string | null;
  line_status: string | null;
  line_price_before_discounts_excl_tax: string | null;
  post_discount_addon_total_excl_tax: string | null;
  quantity: number;
  is_parent_line: boolean;
  is_child_line: boolean;
}
export interface TsicommonOscarappsCustomerServicesUnifiedOrderShipmentEvent {
  status_code:
    | "PENDING"
    | "SHIPPED"
    | "PREPARE_TO_SHIP"
    | "ARRIVED_AT_LOCAL_CARRIER"
    | "READY_DELIVERY"
    | "DELIVERY_SCHEDULED"
    | "OUT_FOR_DELIVERY"
    | "DELIVERED"
    | "CANCELED"
    | "RETURN_REQUESTED"
    | "RETURN_APPROVED"
    | "REPLACEMENT_REQUESTED"
    | "REPLACEMENT_APPROVED"
    | null;
  status_description: string;
  event_date: string;
}
export interface OrderPipelineConfig_1E9Aa3253E {
  freight_delivery_steps: OrderOrderPipelineConfig | null;
  trs_delivery_steps: OrderOrderPipelineConfig1 | null;
  small_package_delivery_steps: OrderOrderPipelineConfig2 | null;
  tracking_page_sidebar: OrderOrderPipelineConfig3 | null;
  tracking_page_sidebar_trs: OrderOrderPipelineConfig4 | null;
}
export interface OrderOrderPipelineConfig {
  _type: "StreamField";
  _variant: "order.OrderPipelineConfig.freight_delivery_steps";
  value: FreightDeliverySteps;
  [k: string]: unknown;
}
export interface OrderConfirmed {
  tracking_step_title: CharBlockOrNull;
  tracking_step_copy_condensed?: CharBlockOrNull;
  tracking_step_copy?: CharBlockOrNull;
  tracker_step: null | "Pending";
}
export interface OrderProcessing {
  tracking_step_title: CharBlockOrNull;
  tracking_step_copy_condensed?: CharBlockOrNull;
  tracking_step_copy?: CharBlockOrNull;
  tracker_step: null | "Order Processing";
}
export interface OrderPreparedForShipment {
  tracking_step_title: CharBlockOrNull;
  tracking_step_copy_condensed?: CharBlockOrNull;
  tracking_step_copy?: CharBlockOrNull;
  tracker_step: null | "Order Prepared for Shipment";
}
export interface OrderShipped {
  tracking_step_title: CharBlockOrNull;
  tracking_step_copy_condensed?: CharBlockOrNull;
  tracking_step_copy?: CharBlockOrNull;
  tracker_step: null | "Shipped";
}
export interface ReadyForDelivery {
  tracking_step_title: CharBlockOrNull;
  tracking_step_copy_condensed?: CharBlockOrNull;
  tracking_step_copy?: CharBlockOrNull;
  tracker_step: null | "Arrived at Local Carrier";
}
export interface DeliveryScheduled {
  tracking_step_title: CharBlockOrNull;
  tracking_step_copy_condensed?: CharBlockOrNull;
  tracking_step_copy?: CharBlockOrNull;
  tracker_step: null | "Delivery Scheduled";
}
export interface OutForDelivery {
  tracking_step_title: CharBlockOrNull;
  tracking_step_copy_condensed?: CharBlockOrNull;
  tracking_step_copy?: CharBlockOrNull;
  tracker_step: null | "Out for Delivery";
}
export interface Delivered {
  tracking_step_title: CharBlockOrNull;
  tracking_step_copy_condensed?: CharBlockOrNull;
  tracking_step_copy?: CharBlockOrNull;
  tracker_step: null | "Delivered";
}
export interface OrderOrderPipelineConfig1 {
  _type: "StreamField";
  _variant: "order.OrderPipelineConfig.trs_delivery_steps";
  value: TRSDeliverySteps;
  [k: string]: unknown;
}
export interface OrderOrderPipelineConfig2 {
  _type: "StreamField";
  _variant: "order.OrderPipelineConfig.small_package_delivery_steps";
  value: SmallPackageDeliverySteps;
  [k: string]: unknown;
}
export interface OrderOrderPipelineConfig3 {
  _type: "StreamField";
  _variant: "order.OrderPipelineConfig.tracking_page_sidebar";
  value: TrackingPageSidebar;
  [k: string]: unknown;
}
export interface LinkBlock {
  display_name: CharBlockOrNull;
  page?: PageChooserBlockOrNull;
  external_url?: CharBlockOrNull;
  is_button?: BooleanBlockOrNull;
}
export interface PageChooserBlock {
  id: number;
  url: string;
  title: string;
}
export interface OrderOrderPipelineConfig4 {
  _type: "StreamField";
  _variant: "order.OrderPipelineConfig.tracking_page_sidebar_trs";
  value: TrackingPageSidebar;
  [k: string]: unknown;
}
export interface TsicommonCmsTemplatesValuePropBarBlockTemplate {
  cms: string;
}
export interface TsicommonCmsTemplatesShopCompareGridTemplate {
  tileset: ShopCompareTilesetA86Edf245B | null;
  header_copy: string;
  footer_copy: string;
}
export interface ShopCompareTilesetA86Edf245B {
  id: number;
  shop_tiles: TsicommonCmsShopCompareTileset | null;
  show_size_selector: boolean;
  compare_features: TsicommonCmsShopCompareTileset1 | null;
}
export interface TsicommonCmsShopCompareTileset {
  _type: "StreamField";
  _variant: "tsicommon_cms.ShopCompareTileset.shop_tiles";
  value: ConditionalShopTileBody;
  [k: string]: unknown;
}
export interface ConditionalShopTileBlock {
  shop_tile: TsicommonCmsShopTileOrNull;
  promo_period?: TsicommonCmsPromoPeriodOrNull;
}
export interface TsicommonCms4 {
  id?: number;
  primary_flair?: FlairSubBlockOrNull;
  description?: RichTextBlock;
  title?: CharBlock;
  secondary_flair?: FlairSubBlockOrNull;
  product_image?: ImageChooserBlockOrNull;
  product?: ProductChooserSubBlock;
  category?: CategoryChooserSubBlock;
  custom_header_name?: CharBlock;
  compare_tiles?: CompareTileSnippetBody;
}
export interface CategoryChooserSubBlock {
  id?: number;
  name?: string;
}
export interface TsicommonCms5 {
  id?: number;
  primary_flair?: FlairSubBlockOrNull;
  description?: RichTextBlock;
  title?: CharBlock;
  secondary_flair?: FlairSubBlockOrNull;
  product_image?: ImageChooserBlockOrNull;
  product?: ProductChooserSubBlock;
  category?: CategoryChooserSubBlock;
  compare_features?: CompareFeatureBody;
}
export interface CompareFeatureBlock {
  feature: TsicommonCmsCompareFeatureOrNull;
  icon: ImageChooserBlockOrNull;
  description?: RichTextBlockOrNull;
}
export interface TsicommonCms6 {
  title?: CharBlock;
  tooltip?: RichTextBlockOrNull;
}
export interface TsicommonCmsShopCompareTileset1 {
  _type: "StreamField";
  _variant: "tsicommon_cms.ShopCompareTileset.compare_features";
  value: CompareFeatureSnippetBody;
  [k: string]: unknown;
}
export interface TsicommonCmsTemplatesShopTileTemplate {
  shop_tile: ShopTileC38Ed2Cda5;
  tileset: ShopCompareTileset_32B1E422F2 | null;
}
export interface ShopTileC38Ed2Cda5 {
  compare_tiles: TsicommonCmsShopTile;
  custom_header_name: string | null;
  product: {
    link: string | null;
  };
}
export interface TsicommonCmsShopTile {
  _type: "StreamField";
  _variant: "tsicommon_cms.ShopTile.compare_tiles";
  value: CompareTileSnippetBody;
  [k: string]: unknown;
}
export interface ShopCompareTileset_32B1E422F2 {
  compare_features: TsicommonCmsShopCompareTileset1 | null;
  shop_tiles: TsicommonCmsShopCompareTileset | null;
}
export interface TsicommonCmsTemplatesTabFeatureAttributeBlockTemplate {
  cms: string;
}
export interface TsicommonCmsTemplatesOrderNumberPopupTemplate {
  copy: string;
}
export interface TsicommonCmsTemplatesTrackOrderSummaryTemplate {
  order: TsicommonOscarappsCustomerServicesUnifiedOrderLookupOrder;
  config: OrderPipelineConfig_1E9Aa3253E | null;
  order_number_token: string;
  war_link: string;
}
export interface ReactivatedSerializationContextProcessorsBaseContext {
  template_name: string;
}
export interface ReactivatedSerializationContextProcessorsCSRFProcessor {
  csrf_token: string;
}
export interface ReactivatedSerializationContextProcessorsRequestProcessor {
  request: ReactivatedSerializationContextProcessorsRequest;
}
export interface ReactivatedSerializationContextProcessorsRequest {
  path: string;
  url: string;
  csp_nonce: string | null;
}
export interface ReactivatedSerializationContextProcessorsStaticProcessor {
  STATIC_URL: string;
}
export interface ThelabuiContextProcessorsTranslationProcessor {
  i18n: ThelabuiContextProcessorsTranslationCatalog;
}
export interface ThelabuiContextProcessorsTranslationCatalog {
  language: ThelabuiTypesLanguage;
  catalog: ThelabuiContextProcessorsCatalogEntry[];
  formats: ThelabuiContextProcessorsFormatEntry[];
}
export interface ThelabuiContextProcessorsCatalogEntry {
  context: string;
  key: string;
  value: string | string[];
}
export interface ThelabuiContextProcessorsFormatEntry {
  key: string;
  value: string | number | string[];
}
export interface ServerContextProcessorsSiteURLContext {
  urls: ServerContextProcessorsSiteURLs;
}
export interface ServerContextProcessorsSiteURLs {
  home: string;
  contact_link: string | null;
  customer_lookup_orders_by_email: string | null;
  customer_service: string | null;
  finance_link: string | null;
  find_a_retailer: string | null;
  how_will_i_receive_my_card: string | null;
  offers_link: string | null;
  reviews_link: string | null;
  mattresses_link: string | null;
  finance_link_top: string | null;
  tempur_pedic_stores: string | null;
  contact_us_form: string | null;
}
export interface ServerContextProcessorsSiteSettingsContext {
  settings: ServerContextProcessorsSiteSettings;
}
export interface ServerContextProcessorsSiteSettings {
  app_slug: string;
  app_display_name: string;
  pre_order_phone_number_display: string;
  pre_order_phone_number_link: string;
  about_order_phone_number_display: string;
  about_order_phone_number_link: string;
  service_website_phone_number_display: string;
  service_website_phone_number_link: string;
  support_website_phone_number_display: string;
  support_website_phone_number_link: string;
  support_contact_hours: string;
  financing_default_plan: FinancingPlan_32Abe7Dbbd | null;
  financing_advertising_plans: FinancingPlan_2Fb8450093[];
  google_recaptcha_sitekey: string | null;
  metrics_api: string | null;
  reviews_api: string;
  retail_locator_api: string;
  google_maps_api_key: string | null;
  basket_financing_fine_print: string;
  checkout_generic_fine_print: string;
  checkout_financing_fine_print: string;
  checkout_financing_fine_print_mobile_content: string;
  pre_approval_modal_fine_print: string;
  predicted_delivery_date_display_type: "disabled" | "show-conservative" | "show-aggressive";
  preferred_delivery_date_display_type: "disabled" | "show-conservative" | "show-aggressive";
  enable_basket_sidebar_questions_block: boolean;
  enable_checkout_sidebar_questions_block: boolean;
  basket_sidebar_extra_content: string;
  checkout_sidebar_extra_content: string;
  disable_basket_free_shipping_message: boolean;
  enable_ecom: boolean;
  enable_financing: boolean;
  show_pre_approval: boolean;
  show_prequal_cart: boolean;
  show_prequal_footer: boolean;
  retail_locator_country: string | null;
  retail_locator_brand: string | null;
  retail_locator_display_enabled: boolean;
  wfrs_prescreen_api: string;
  financing_modal_type: string;
  bundle_callout_text: string;
  primary_promo_callout_message: string | null;
  secondary_promo_callout_message: string | null;
  footer_settings: TsicommonContextProcessorsFooterSettings | null;
  reviews_disclosures_settings: {
    [k: string]: string;
  };
  link_rewrite_rules: LinkRewriteRules_03B4F40210 | null;
  level_marketing_copy: {
    [k: string]: TsicommonContextProcessorsLevelMarketingCopy;
  };
  variant_level_core_features: string | null;
  enable_split_pay: boolean;
  show_prequal_toolbox: boolean;
  lang_picker: ServerContextProcessorsLangPickerEntry[];
}
export interface FinancingPlan_32Abe7Dbbd {
  product_price_threshold: string;
  apr: string;
  term_months: number;
  description: string;
  fine_print_superscript: string;
}
export interface FinancingPlan_2Fb8450093 {
  product_price_threshold: string;
  term_months: number;
  apr: string;
  fine_print_superscript: string;
  description: string;
  is_default_plan: boolean;
  backend_type: {
    code: string;
  };
}
export interface TsicommonContextProcessorsFooterSettings {
  talk_modal_title_top: string;
  talk_modal_text_top: string;
  talk_modal_hours_top: string;
  talk_modal_title_middle: string;
  talk_modal_text_middle: string;
  talk_modal_hours_middle: string;
  talk_modal_title_bottom: string;
  talk_modal_text_bottom: string;
  talk_modal_hours_bottom: string;
  talk_modal_links: TsicommonContextProcessorsFooterTalkModalLink[];
}
export interface TsicommonContextProcessorsFooterTalkModalLink {
  id: string;
  title: string;
  url: string;
}
export interface LinkRewriteRules_03B4F40210 {
  rules: {
    pattern: string;
    action: string;
  }[];
}
export interface TsicommonContextProcessorsLevelMarketingCopy {
  main_copy: string;
  description_copy: string;
}
export interface ServerContextProcessorsLangPickerEntry {
  language_code: string;
  display_name: string;
  locale_autonym: string;
  url: string;
}
export class RPC {
    constructor(public requester: rpcUtils.Requester) {
    }
}
export type UUID = `${string}-${string}-${string}-${string}-${string}`;

import type {Renderer as GenericRenderer} from "reactivated/dist/render.mjs";
export type Renderer = GenericRenderer<_Types["Context"]>;

export const rpc = new RPC(typeof window != "undefined" ? rpcUtils.defaultRequester : null as any);
import React from "react"
import * as generated from "reactivated/dist/generated";
import * as rpcUtils from "reactivated/dist/rpc";
import {constants} from "./constants";
export {constants};

export function classNames(...classes: (string | undefined | null | false)[]) {
    return classes.filter(Boolean).join(" ");
}

// Note: this needs strict function types to behave correctly with excess properties etc.
export type Checker<P, U extends (React.FunctionComponent<P> | React.ComponentClass<P>)> = {};

export type Result<TSuccess, TInvalid> = rpcUtils.Result<TSuccess, TInvalid, _Types["RPCPermission"]>;

export {Context} from "./context";
import {Context} from "./context";

import * as forms from "reactivated/dist/forms";
export type {FormHandler} from "reactivated/dist/forms";
export {reverse} from "./urls";

export const Provider = (props: {value: _Types["Context"]; children: React.ReactNode}) => {
    const [value, setValue] = React.useState(props.value);

    return (
        <Context.Provider value={{...value, setValue}}>
            {props.children}
        </Context.Provider>
    );
};

export const getServerData = () => {
    const props: Record<string, unknown> = (window as any).__PRELOADED_PROPS__;
    const context: _Types["Context"] = (window as any).__PRELOADED_CONTEXT__;

    return {props, context};
};

export type models = _Types["globals"]["models"];

export type {FieldHandler} from "./forms";
export {Form, FormSet, Widget, useForm, useFormSet, ManagementForm} from "reactivated/dist/forms";


import {Template as BasePageTemplateImplementation} from "@client/templates/BasePageTemplate"
export type BasePageTemplateCheck = Checker<_Types["BasePageTemplateProps"], typeof BasePageTemplateImplementation>;

export namespace templates {
    export type BasePageTemplate = _Types["BasePageTemplateProps"];
}


        



import {Template as BaseFormPageTemplateImplementation} from "@client/templates/BaseFormPageTemplate"
export type BaseFormPageTemplateCheck = Checker<_Types["BaseFormPageTemplateProps"], typeof BaseFormPageTemplateImplementation>;

export namespace templates {
    export type BaseFormPageTemplate = _Types["BaseFormPageTemplateProps"];
}


        



import {Template as BaseFormPageLandingPageTemplateImplementation} from "@client/templates/BaseFormPageLandingPageTemplate"
export type BaseFormPageLandingPageTemplateCheck = Checker<_Types["BaseFormPageLandingPageTemplateProps"], typeof BaseFormPageLandingPageTemplateImplementation>;

export namespace templates {
    export type BaseFormPageLandingPageTemplate = _Types["BaseFormPageLandingPageTemplateProps"];
}


        



import {Template as ExamplePageTemplateImplementation} from "@client/templates/ExamplePageTemplate"
export type ExamplePageTemplateCheck = Checker<_Types["ExamplePageTemplateProps"], typeof ExamplePageTemplateImplementation>;

export namespace templates {
    export type ExamplePageTemplate = _Types["ExamplePageTemplateProps"];
}


        



import {Template as LabUIToolboxSnippetPreviewImplementation} from "@client/templates/LabUIToolboxSnippetPreview"
export type LabUIToolboxSnippetPreviewCheck = Checker<_Types["LabUIToolboxSnippetPreviewProps"], typeof LabUIToolboxSnippetPreviewImplementation>;

export namespace templates {
    export type LabUIToolboxSnippetPreview = _Types["LabUIToolboxSnippetPreviewProps"];
}


        



import {Template as CheckoutHeaderTemplateImplementation} from "@client/templates/CheckoutHeaderTemplate"
export type CheckoutHeaderTemplateCheck = Checker<_Types["CheckoutHeaderTemplateProps"], typeof CheckoutHeaderTemplateImplementation>;

export namespace templates {
    export type CheckoutHeaderTemplate = _Types["CheckoutHeaderTemplateProps"];
}


        



import {Template as SiteHeaderTemplateImplementation} from "@client/templates/SiteHeaderTemplate"
export type SiteHeaderTemplateCheck = Checker<_Types["SiteHeaderTemplateProps"], typeof SiteHeaderTemplateImplementation>;

export namespace templates {
    export type SiteHeaderTemplate = _Types["SiteHeaderTemplateProps"];
}


        



import {Template as RichNavigationTemplateImplementation} from "@client/templates/RichNavigationTemplate"
export type RichNavigationTemplateCheck = Checker<_Types["RichNavigationTemplateProps"], typeof RichNavigationTemplateImplementation>;

export namespace templates {
    export type RichNavigationTemplate = _Types["RichNavigationTemplateProps"];
}


        



import {Template as FlairSubBlockTemplateImplementation} from "@client/templates/FlairSubBlockTemplate"
export type FlairSubBlockTemplateCheck = Checker<_Types["FlairSubBlockTemplateProps"], typeof FlairSubBlockTemplateImplementation>;

export namespace templates {
    export type FlairSubBlockTemplate = _Types["FlairSubBlockTemplateProps"];
}


        



import {Template as DynamicPriceTemplateImplementation} from "@client/templates/DynamicPriceTemplate"
export type DynamicPriceTemplateCheck = Checker<_Types["DynamicPriceTemplateProps"], typeof DynamicPriceTemplateImplementation>;

export namespace templates {
    export type DynamicPriceTemplate = _Types["DynamicPriceTemplateProps"];
}


        



import {Template as TrackOrderDetailsTemplateImplementation} from "@client/templates/TrackOrderDetailsTemplate"
export type TrackOrderDetailsTemplateCheck = Checker<_Types["TrackOrderDetailsTemplateProps"], typeof TrackOrderDetailsTemplateImplementation>;

export namespace templates {
    export type TrackOrderDetailsTemplate = _Types["TrackOrderDetailsTemplateProps"];
}


        



import {Template as ValuePropBarBlockTemplateImplementation} from "@client/templates/ValuePropBarBlockTemplate"
export type ValuePropBarBlockTemplateCheck = Checker<_Types["ValuePropBarBlockTemplateProps"], typeof ValuePropBarBlockTemplateImplementation>;

export namespace templates {
    export type ValuePropBarBlockTemplate = _Types["ValuePropBarBlockTemplateProps"];
}


        



import {Template as ShopCompareGridTemplateImplementation} from "@client/templates/ShopCompareGridTemplate"
export type ShopCompareGridTemplateCheck = Checker<_Types["ShopCompareGridTemplateProps"], typeof ShopCompareGridTemplateImplementation>;

export namespace templates {
    export type ShopCompareGridTemplate = _Types["ShopCompareGridTemplateProps"];
}


        



import {Template as ShopTileTemplateImplementation} from "@client/templates/ShopTileTemplate"
export type ShopTileTemplateCheck = Checker<_Types["ShopTileTemplateProps"], typeof ShopTileTemplateImplementation>;

export namespace templates {
    export type ShopTileTemplate = _Types["ShopTileTemplateProps"];
}


        



import {Template as TabFeatureAttributeBlockTemplateImplementation} from "@client/templates/TabFeatureAttributeBlockTemplate"
export type TabFeatureAttributeBlockTemplateCheck = Checker<_Types["TabFeatureAttributeBlockTemplateProps"], typeof TabFeatureAttributeBlockTemplateImplementation>;

export namespace templates {
    export type TabFeatureAttributeBlockTemplate = _Types["TabFeatureAttributeBlockTemplateProps"];
}


        



import {Template as OrderNumberPopupTemplateImplementation} from "@client/templates/OrderNumberPopupTemplate"
export type OrderNumberPopupTemplateCheck = Checker<_Types["OrderNumberPopupTemplateProps"], typeof OrderNumberPopupTemplateImplementation>;

export namespace templates {
    export type OrderNumberPopupTemplate = _Types["OrderNumberPopupTemplateProps"];
}


        



import {Template as TrackOrderSummaryTemplateImplementation} from "@client/templates/TrackOrderSummaryTemplate"
export type TrackOrderSummaryTemplateCheck = Checker<_Types["TrackOrderSummaryTemplateProps"], typeof TrackOrderSummaryTemplateImplementation>;

export namespace templates {
    export type TrackOrderSummaryTemplate = _Types["TrackOrderSummaryTemplateProps"];
}


        
export {Iterator, CSRFToken, createRenderer} from "./forms";
export {getTemplate} from "./template";

